var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtgrInfluencer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 10.7719V9.85522C10.0833 9.49055 10.2282 9.14082 10.486 8.88295C10.7439 8.62509 11.0936 8.48022 11.4583 8.48022C11.823 8.48022 12.1727 8.62509 12.4306 8.88295C12.6884 9.14082 12.8333 9.49055 12.8333 9.85522V11.2302",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 11.2302V5.2719C15.5833 4.90722 15.7282 4.55749 15.986 4.29962C16.2439 4.04176 16.5936 3.8969 16.9583 3.8969C17.323 3.8969 17.6727 4.04176 17.9306 4.29962C18.1885 4.55749 18.3333 4.90722 18.3333 5.2719V14.8969C18.3333 16.3556 17.7539 17.7545 16.7224 18.786C15.691 19.8174 14.292 20.3969 12.8333 20.3969H11H11.1907C10.2798 20.3971 9.38316 20.171 8.58125 19.739C7.77935 19.307 7.09729 18.6826 6.59632 17.9219L6.41665 17.6469C6.13065 17.2081 5.1266 15.4579 3.40449 12.3962C3.2289 12.0841 3.18199 11.7158 3.27375 11.3697C3.36551 11.0236 3.58869 10.7269 3.89582 10.5427C4.2231 10.3469 4.60633 10.2658 4.98487 10.3123C5.36342 10.3588 5.71565 10.5302 5.98582 10.7994L7.33332 12.1469",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 9.85522C12.8333 9.49055 12.9782 9.14082 13.236 8.88295C13.4939 8.62509 13.8436 8.48022 14.2083 8.48022C14.573 8.48022 14.9227 8.62509 15.1806 8.88295C15.4384 9.14082 15.5833 9.49055 15.5833 9.85522V11.2302M7.33331 12.1469V4.35522C7.33331 3.99055 7.47818 3.64082 7.73604 3.38295C7.9939 3.12509 8.34364 2.98022 8.70831 2.98022C9.07299 2.98022 9.42272 3.12509 9.68059 3.38295C9.93845 3.64082 10.0833 3.99055 10.0833 4.35522V11.2302",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtgrInfluencer);
export default __webpack_public_path__ + "static/media/ctgr-influencer.44f93af5a339594c09cee1094a432e91.svg";
export { ForwardRef as ReactComponent };